
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="布局设置" fileName="layout-settings.md" />
        <demo-block>
        <div><p>1、通过设置 <code>layout</code> 属性，改变布局。<br>2、<code>layout</code> 属性支持以下配置项：<br><code>total</code>：显示总条数、<code>prev</code>：显示上一页按钮、<code>pager</code>：显示页码按钮、<code>next</code>：显示下一页按钮、<code>sizer</code>：显示每页大小设置、<code>jumper</code>：显示跳转文本框</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;div&gt;
            &lt;div class=&quot;mb20 bold&quot;&gt;不显示页码按钮&lt;/div&gt;
            &lt;ve-pagination :total=&quot;600&quot; :layout=&quot;['total', 'prev', 'next', 'sizer', 'jumper']&quot; /&gt;
        &lt;/div&gt;
        &lt;div&gt;
            &lt;div class=&quot;mt30 mb20 bold&quot;&gt;调整显示顺序&lt;/div&gt;
            &lt;ve-pagination
                :total=&quot;600&quot;
                :layout=&quot;['total', 'sizer', 'prev', 'pager', 'next', 'jumper']&quot;
            /&gt;
        &lt;/div&gt;

        &lt;div&gt;
            &lt;div class=&quot;mt30 mb20 bold&quot;&gt;完整布局&lt;/div&gt;
            &lt;ve-pagination
                :total=&quot;600&quot;
                :layout=&quot;['total', 'prev', 'pager', 'next', 'sizer', 'jumper']&quot;
            /&gt;
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('div',[_c('div',{staticClass:"mb20 bold"},[_vm._v("不显示页码按钮")]),_vm._v(" "),_c('ve-pagination',{attrs:{"total":600,"layout":['total', 'prev', 'next', 'sizer', 'jumper']}})],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"mt30 mb20 bold"},[_vm._v("调整显示顺序")]),_vm._v(" "),_c('ve-pagination',{attrs:{"total":600,"layout":['total', 'sizer', 'prev', 'pager', 'next', 'jumper']}})],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"mt30 mb20 bold"},[_vm._v("完整布局")]),_vm._v(" "),_c('ve-pagination',{attrs:{"total":600,"layout":['total', 'prev', 'pager', 'next', 'sizer', 'jumper']}})],1)])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  